import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import useAcoesDemonstrativo from "../hooks/useAcoesDemonstrativo";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import SelectUf from "../../../../components/UI/SelectInput/SelectUf";
import useBuscaComposicao from "../hooks/useBuscaComposicao";
import TextInputSpecialNumberFormik from "../../../../components/UI/TextInput/TextInputSpecialNumberFormik";

const DemonstrativoAI = ({ formik, sqAcaoFiscal, sqItemOcorrencia, dadosOcorrencia }) => {
  const [tituloUF, setTituloUF] = useState("");
  const [tituloCnpj, setTituloCnpj] = useState("");
  const { handleMoneyChange, calculaDataVencimento, calculaIcmsDet } = useAcoesDemonstrativo({ formik });
  const { buscaComposicao, sentidoOperacao } = useBuscaComposicao({ sqAcaoFiscal, sqItemOcorrencia });

  const { setFieldValue } = formik;

  useEffect(() => {
    if (dadosOcorrencia) {
      setFieldValue("sqAcaoFiscal", sqAcaoFiscal);
      setFieldValue("sqItemOcorrencia", sqItemOcorrencia);
      setFieldValue("sqItem", dadosOcorrencia.sqItem);
      setFieldValue("nuCnpjRemet", dadosOcorrencia.nuCnpjRemet);
      setFieldValue("sequencialUf", dadosOcorrencia.sequencialUf);
      setFieldValue("nuItem", dadosOcorrencia.nuItem);
      setFieldValue("txChave", dadosOcorrencia.txChave);
      setFieldValue("dtEmissao", dadosOcorrencia.dtEmissao);
      setFieldValue("dtVencimento", dadosOcorrencia.dtVencimento);
      setFieldValue("dsItem", dadosOcorrencia.dsItem);
      setFieldValue("vlProduto", dadosOcorrencia.vlProduto);
      setFieldValue("vlBaseCalculo", dadosOcorrencia.vlBaseCalculo);
      setFieldValue("vlDifAliquota", dadosOcorrencia.vlDifAliquota);
      setFieldValue("vlIcmsRecolhido", dadosOcorrencia.vlIcmsRecolhido);
      setFieldValue("pcIcmsAuditor", dadosOcorrencia.pcIcmsAuditor);
      setFieldValue("vlIcmsCalculado", dadosOcorrencia.vlIcmsCalculado);
      setFieldValue("vlIcms", dadosOcorrencia.vlIcms);
      setFieldValue("txJustificativa", dadosOcorrencia.txJustificativa);
      setFieldValue("tipoDetalhamento", dadosOcorrencia.tipoDetalhamento);
    }

    if (sqAcaoFiscal !== null) {
      buscaComposicao();
    }
  }, [setFieldValue, dadosOcorrencia, sqAcaoFiscal, sqItemOcorrencia, buscaComposicao]);

  useEffect(() => {
    if (sentidoOperacao === "S") {
      setTituloUF("UF Destino");
      setTituloCnpj("CNPJ/CPF Destinatário");
    } else {
      // sentidoOperacao = 'E'
      setTituloUF("UF Origem");
      setTituloCnpj("CNPJ/CPF Emitente");
    }
  }, [sentidoOperacao]);

  return (
    <>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>{tituloCnpj}:</Form.Label>
          <TextInputSpecialNumberFormik formik={formik} field="nuCnpjRemet" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>{tituloUF}:</Form.Label>
          <SelectUf formik={formik} field="sequencialUf" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>N° Nota Fiscal:</Form.Label>
          <TextInputSpecialNumberFormik formik={formik} field="nuItem" />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Chave:</Form.Label>
          <TextInputSpecialNumberFormik formik={formik} field="txChave" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Data de Emissão:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtEmissao" evento={calculaDataVencimento} />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Data de Vencimento:</Form.Label>
          <DateTimeInputFormik formik={formik} field="dtVencimento" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={12}>
          <span>Descrição do Produto:</span>
          <HtmlEditor formik={formik} field="dsItem" />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Valor do Produto (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlProduto"
            prefix=" "
            type="number"
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Base de Cálculo (R$):</Form.Label>
          <TextInputMoneyFormik formik={formik} field="vlBaseCalculo" prefix=" " onChange={handleMoneyChange} />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Alíquota ICMS NFE (%):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlDifAliquota"
            prefix=" "
            type="number"
            onChange={handleMoneyChange}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>ICMS NFE (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcmsRecolhido"
            prefix=" "
            type="number"
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>Alíquota ICMS Correta (%):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="pcIcmsAuditor"
            prefix=" "
            type="number"
            onChange={handleMoneyChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>ICMS Correto (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcmsCalculado"
            prefix=" "
            type="number"
            onChange={handleMoneyChange}
            evento={() => calculaIcmsDet("AI")}
          />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={4}>
          <Form.Label>ICMS a Recolher (R$):</Form.Label>
          <TextInputMoneyFormik
            formik={formik}
            field="vlIcms"
            prefix=" "
            type="number"
            onChange={handleMoneyChange}
            disable
          />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group className="mb-3" as={Col} sm={12} md={12}>
          <span>Justificativa:</span>
          <HtmlEditor formik={formik} field="txJustificativa" />
        </Form.Group>
      </Row>
    </>
  );
};

export default DemonstrativoAI;
